import {Pipe, PipeTransform} from '@angular/core';
import {Geometry} from '@turf/helpers';

@Pipe({
    name: 'geoLatLng'
})
export class GeoLatLngPipe implements PipeTransform {

    transform<T>(value: Geometry): google.maps.LatLngLiteral {
        let useValue = value?.coordinates;
        if (!useValue) {
            return null;
        }
        while (typeof useValue[0] !== 'number') {
            useValue = useValue[0];
        }
        return {lng: useValue[0], lat: +useValue[1]};
    }

}
